import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { setMe } from '../../app/setMe/setMe.slice';
import logoutRequest from './logout.repository';

type InitialState = {
  loading: boolean;
};

const initialState: InitialState = {
  loading: false,
};

/**
 * Cikis: once sunucudaki cerez silinir, ardindan HER DURUMDA lokal state
 * temizlenir. Istek hatasi yutulur; cerez zaten gecersiz olabilir ve backend
 * bu uc icin kimlik zorunlu tutmuyor.
 */
export const logout = createAsyncThunk('logout', async (_, { dispatch }) => {
  try {
    await logoutRequest();
  } catch (error) {
    console.warn('[logout] istek basarisiz, lokal temizlik yapiliyor:', error);
  }
  dispatch(setMe());
});

const logoutSlice = createSlice({
  name: 'logout',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(logout.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(logout.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(logout.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default logoutSlice.reducer;
